<script>
  import Input from '../../lib/Input.svelte';
  import Slider from '../../lib/Slider.svelte';
  import StateSelect from '../../lib/StateSelect/StateSelect.svelte';
  import FilingStatusSelect from '../../lib/FilingStatusSelect/FilingStatusSelect.svelte';
  import { calculateCombinedFederalTaxAmount, calculateStateTaxAmount } from '../calculator';
  import ResultPanel from '../ResultPanel.svelte';

  let form = {
    longTermGains: 0,
    shortTermGains: 0,
    annualIncome: 0,
    status: "single",
    state: "california"
  };

  $: totalGains = Number(form.shortTermGains) + Number(form.longTermGains);

  $: stateTaxAmount = calculateStateTaxAmount({
    gainAmount: totalGains,
    annualIncome: form.annualIncome,
    fillingStatus: form.status,
    state: form.state
  });

  $: federalTaxAmount = calculateCombinedFederalTaxAmount({
    shortTermGainsAmount: form.shortTermGains,
    longTermGainsAmount: form.longTermGains,
    annualIncome: form.annualIncome,
    fillingStatus: form.status
  });

</script>

<div class="border rounded bg-white p-8 mt-10">
  <div class="grid grid-cols-1 md:grid-cols-3 gap-x-12">
    <div>
      <Input bind:value={form.longTermGains} label="Total Long Term Capital Gains" />
      <Slider bind:value={form.longTermGains} />
    </div>
    <div>
      <Input bind:value={form.shortTermGains} label="Total Short Term Capital Gains" />
      <Slider bind:value={form.shortTermGains} />
    </div>
    <div>
      <Input bind:value={form.annualIncome} label="Annual Income" />
      <Slider bind:value={form.annualIncome} />
    </div>
  </div>
  <div class="grid grid-cols-2 gap-x-12 mt-12">
    <div class="flex justify-end">
      <div class="w-full md:w-80">
        <StateSelect bind:value={form.state} />
      </div>
    </div>
    <div class="flex justify-start">
      <div class="w-full md:w-80">
        <FilingStatusSelect bind:value={form.status} />
      </div>
    </div>
  </div>
</div>
<ResultPanel totalTaxableAmount={totalGains} federalResult={federalTaxAmount} stateResult={stateTaxAmount} />